var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.032,
    height: 62.233,
    viewBox: "0 0 59.032 62.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1a862o",
    "data-name": "1a862o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M29.257,57.225c-8.965,0-17.93-.029-26.9.033-1.434,0-1.89-.373-1.882-1.836q.087-14.585,0-29.17c0-1.442.92-2.636.829-4.145-.062-1.036,1.107-.771,1.815-.771,4.48-.025,8.965-.075,13.445,0,1.463.029,2.014-.22,1.965-1.865-.137-4.617.1-9.247-.116-13.86-.07-1.965,1.956-3.175,1.426-5.2-.083-.414.767-.414,1.235-.414H37.422c.539,0,1.243-.1,1.289.663.079,2.392,1.194,4.559,1.053,7.067-.265,4.746-.075,4.758,4.729,4.758,3.656,0,7.311.029,10.967,0,1.078,0,1.355.307,1.683,1.426,1.144,3.954.6,7.958.746,11.937a1.087,1.087,0,0,0,.7,1.243c.962.439.945,3.1,0,3.664-.489.294-.721.5-.717,1.04,0,2.76-.128,5.525.066,8.289.075,1.086,1.766,1.716,1.285,3.22-.195.609.128,1.384-.9,1.571-.829.145-.414.9-.414,1.372-.037,3.1-.079,6.217,0,9.309.037,1.364-.414,1.753-1.77,1.745C47.187,57.192,38.222,57.225,29.257,57.225ZM56.479,40.646c.037-2.9.054-5.761.116-8.642,0-.829-.2-1.219-1.14-1.21q-7.212.058-14.419,0c-.941,0-1.181.394-1.152,1.243.116,2.876-.2,5.757.157,8.629.145.414.522.361.829.361H55.629c.327-.041.713.046.85-.414ZM20.743,7.758c.829.443.634.9.634,1.264q.025,8.588,0,17.18V54.352c0,.63-.443,1.554.908,1.608,1.447.058,1.09-.891,1.1-1.658.025-1.795.087-3.593,0-5.388-.079-1.388.286-1.994,1.807-1.923,2.412.116,4.829.079,7.245,0,1.3-.041,1.886.3,1.791,1.741-.12,1.923.083,3.867-.062,5.8-.133,1.824,1.082,1.409,2.006,1.347s2.234.717,2.23-1.326q-.079-24.3.012-48.622c0-1.214-.414-1.48-1.517-1.467q-7.759.075-15.522,0c-1.115,0-1.575.22-1.571,1.463q.062,24.429.041,48.85c0,.414-.216,1.032.9,1.082ZM18.518,40.886c0-4.476-.058-8.957.033-13.437.029-1.388-.414-1.708-1.732-1.683-4.476.079-8.957.058-13.437,0-1.086,0-1.567.162-1.558,1.43q.079,13.644,0,27.289c0,1.21.39,1.471,1.521,1.459,4.559-.062,9.094-.083,13.64,0,1.347.029,1.579-.414,1.558-1.637C18.468,49.847,18.518,45.367,18.518,40.886Zm29.73-23.849c-2.2,0-4.414.058-6.632-.025-1.243-.05-1.857.17-1.77,1.633.128,2.267.087,4.559,0,6.818-.041,1.127.22,1.558,1.451,1.538q6.926-.1,13.856,0c1.243,0,1.476-.414,1.438-1.546-.079-2.2-.1-4.414,0-6.632.07-1.388-.245-1.944-1.766-1.844-2.168.166-4.393.058-6.586.058Zm.145,27.745c-2.412,0-4.829.046-7.241,0-.995-.029-1.3.265-1.277,1.272.066,2.823.054,5.653,0,8.48,0,1,.166,1.517,1.343,1.447.982-.058,1.658,0,1.658-1.376,0-1.608-.829-3.73.385-4.721s3.187-.2,4.833-.29h.622c4.783,0,4.783,0,4.895,4.824a2.307,2.307,0,0,1,0,.414c-.174,1.177.58,1.165,1.4,1.119s1.658.278,1.621-1.127c-.083-2.963-.062-5.931,0-8.895,0-.941-.319-1.165-1.19-1.144-2.367.029-4.708,0-7.054,0Zm-19.41-41.6h7.245c.829,0,1.3-.145,1.272-1.123-.033-1.053-.771-.783-1.318-.783H22.115c-.68,0-1.181.021-1.165.953s.535.966,1.206.962ZM47.871,13.755H41.276c-.655,0-1.417-.2-1.434.908s.626,1.024,1.359,1.02H54.4c.667,0,1.376.166,1.405-.945s-.638-.991-1.335-.986ZM32.95,52.264c0-.891-.07-1.786,0-2.669.124-1.243-.564-1.372-1.5-1.214-.8.137-2.072-.593-2.072,1.119.025,1.778,0,3.556,0,5.334,0,.452-.075.916.58,1.127,1.836.6,2.93-.145,2.934-2.072.046-.531.041-1.078.041-1.625ZM10.493,24.08H17.3c.472,0,1.181.3,1.243-.613.046-.829-.551-.8-1.111-.8H3.617c-.51,0-.995,0-1.04.667-.058.875.58.754,1.123.754ZM28.109,52.3c0-.962-.033-1.923,0-2.9.058-1.488-1.053-.941-1.737-.97s-1.732-.414-1.658,1.044c.079,1.782,0,3.573.025,5.363,0,.439-.12.9.58,1.1,1.844.531,2.781-.1,2.789-2.006-.012-.547-.017-1.1-.012-1.65ZM48.919,42.271H40.845c-.414,0-1.082-.24-1.123.5-.054.875.659.7,1.177.7h15.75c.485,0,1.219.269,1.219-.642,0-.779-.647-.555-1.069-.56Q52.844,42.269,48.919,42.271Zm-.211-14H40.833c-.456,0-1.04-.128-1.127.564-.1.829.551.642.978.642h16.14c.414,0,1.065.195,1.02-.613-.041-.734-.63-.593-1.082-.593-2.677,0-5.363,0-8.053,0ZM52.293,53.49a5.474,5.474,0,0,1,0-.829c.24-1.492-.448-1.791-1.836-1.828-1.567-.041-1.9.58-1.732,1.927a12.255,12.255,0,0,1,0,2.072c-.033.721.128,1.082.991,1.156,2.45.2,2.578.128,2.578-2.5Zm-8.169-.224v.618c-.062,1.19-.2,2.135,1.658,2.135s1.737-.933,1.658-2.126a5.8,5.8,0,0,1,0-1.243c.236-1.455-.377-1.732-1.778-1.8-2.18-.1-1.405,1.372-1.538,2.416Z",
    transform: "translate(-0.281 0.009)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M7.4,142.566H0v-.506H57.4l.046.46H54.035c-1.169,0-2.342.029-3.515.046H7.415Z",
    transform: "translate(0 -83.176)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M28,148.81H55.26v.361H28Z",
    transform: "translate(-16.395 -87.129)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M70.392,144.83c.414,1.306-.692.729-1.053.738-3.585.058-7.17.046-10.756.046q-11.377,0-22.75-.025c-.638,0-1.571.5-1.873-.638,1.372,0,2.744-.05,4.112-.054Z",
    transform: "translate(-19.885 -84.798)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M102.76,148.912a5.645,5.645,0,0,1,3.772-.108A5.422,5.422,0,0,1,102.76,148.912Z",
    transform: "translate(-60.169 -86.966)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M21.224,144.95c-1.3,1.148-2.64.912-4,.133a.792.792,0,0,1,.1-.149.951.951,0,0,1,.178-.1Z",
    transform: "translate(-10.083 -84.798)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M21.61,144.043l-3.73-.12v-.642h3.78C21.631,143.537,21.619,143.79,21.61,144.043Z",
    transform: "translate(-10.469 -83.891)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M68.457,29.618V42.23c0,.618.327,1.616-.709,1.6-.829,0-.63-.916-.634-1.5V16.682c0-.584-.182-1.492.647-1.492,1.053,0,.68,1,.684,1.6.025,4.277,0,8.551,0,12.824Z",
    transform: "translate(-39.287 -8.89)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M79.963,29.583V42.378c0,.58.228,1.463-.618,1.5s-.663-.862-.663-1.43V16.66c0-.539-.34-1.48.572-1.48,1.044,0,.688,1.007.692,1.612C79.976,21.057,79.963,25.318,79.963,29.583Z",
    transform: "translate(-46.035 -8.884)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M55.782,29.218V16.593c0-.568-.265-1.467.642-1.463s.626.912.63,1.467q.025,12.849,0,25.668c0,.576.253,1.509-.547,1.554-1.036.062-.721-.953-.721-1.563C55.77,37.913,55.782,33.566,55.782,29.218Z",
    transform: "translate(-32.638 -8.855)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M9.576,91.407c.336,1.571-.622,1.558-1.782,1.658-1.534.1-1.563-.676-1.658-1.861C6.024,89.625,6.857,89.65,8,89.583,9.493,89.471,9.825,90.164,9.576,91.407Z",
    transform: "translate(-3.587 -52.443)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M7.929,81.077c-1.463.315-1.724-.414-1.774-1.7-.05-1.413.439-1.708,1.766-1.712s1.791.348,1.745,1.728C9.624,80.708,9.355,81.417,7.929,81.077ZM7.9,78.358c-.916-.112-.962.464-.982,1.148-.033.829.456.829,1.049.829.663,0,.995-.158.986-.912S8.725,78.221,7.9,78.358Z",
    transform: "translate(-3.602 -45.474)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M31.86,91.14c-.414-1.534.531-1.567,1.712-1.629,1.442-.075,1.621.555,1.658,1.8.05,1.455-.531,1.658-1.8,1.7C31.947,93.051,31.595,92.442,31.86,91.14Zm1.637-.883c-.634-.166-.875.195-.866.879,0,.56-.083,1.09.775,1.073.642,0,1.044-.116.986-.883-.046-.547.037-1.144-.916-1.069Z",
    transform: "translate(-18.597 -52.404)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M8.107,69.149c-1.43.3-1.944-.187-1.927-1.583,0-1.243.24-1.849,1.691-1.782,1.243.054,1.907.207,1.8,1.658C9.586,68.606,9.632,69.638,8.107,69.149Zm.829-1.728c.087-.908-.481-.966-1.156-.966-.767,0-.829.456-.858,1.061-.058.953.543.883,1.177.9.754.021.928-.373.841-1Z",
    transform: "translate(-3.618 -38.511)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M18.949,91.293c-.294-1.351.24-1.8,1.625-1.774,1.268,0,1.824.249,1.77,1.691-.046,1.264-.224,1.873-1.679,1.811C19.414,92.963,18.63,92.764,18.949,91.293Zm1.658.92c.829.124,1.053-.3,1.036-1.049,0-.684-.294-.92-.974-.953-.866-.046-.991.377-.991,1.094s.22,1.032.945.9Z",
    transform: "translate(-11.05 -52.411)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M33.57,77.741c1.546-.414,1.521.539,1.6,1.708.1,1.484-.564,1.658-1.807,1.7-1.521.07-1.563-.667-1.658-1.857C31.617,77.757,32.3,77.509,33.57,77.741Zm-.033,2.537c.887.116.779-.493.8-1.036.029-.713-.311-.908-.986-.9-.854,0-.734.555-.783,1.094C32.5,80.219,32.919,80.36,33.536,80.277Z",
    transform: "translate(-18.562 -45.458)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M33.559,65.878c1.484-.361,1.608.448,1.658,1.683.05,1.434-.51,1.658-1.791,1.7-1.492.05-1.6-.609-1.658-1.828C31.681,65.961,32.274,65.609,33.559,65.878Zm-.087.6c-.8-.1-.862.414-.9,1.011-.046.717.224.941.933.949s.924-.327.9-.991S34.23,66.363,33.472,66.475Z",
    transform: "translate(-18.596 -38.519)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M22.268,79.418c.319,1.438-.365,1.712-1.658,1.741-1.43.033-1.683-.514-1.724-1.807-.046-1.447.518-1.658,1.8-1.683C22.061,77.644,22.567,78.087,22.268,79.418Zm-.605.046c.05-.767-.216-1.148-1.057-1.144s-.875.414-.9,1.04.17,1.02.924.978C21.253,80.313,21.75,80.251,21.663,79.463Z",
    transform: "translate(-11.057 -45.473)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M20.746,69.214c-1.293.249-1.907-.12-1.878-1.583.029-1.243.2-1.873,1.658-1.8,1.181.058,1.944.087,1.8,1.616C22.238,68.555,22.346,69.587,20.746,69.214Zm-.166-2.706c-.626-.149-.875.2-.866.9,0,.589,0,1.073.829,1.044.7,0,1.2-.091,1.136-.982C21.617,66.806,21.409,66.424,20.58,66.507Z",
    transform: "translate(-11.048 -38.539)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M6.256,131.11H21.305v.332H6.21Z",
    transform: "translate(-3.636 -76.765)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M123.709,80.507c-.336-1.658.866-1.335,1.89-1.446,1.724-.191,1.351.966,1.484,1.965.236,1.77-.966,1.33-1.94,1.463C123.415,82.725,123.659,81.6,123.709,80.507Zm2.557.315c.091-.642-.124-.966-.87-.962s-.974.236-.937.945c.033.613.124,1.028.9,1.036s.953-.332.928-1.02Z",
    transform: "translate(-72.401 -46.276)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M112.59,79.118c1.372-.311,1.728.307,1.732,1.658s-.29,1.791-1.691,1.753c-1.268-.033-1.865-.24-1.8-1.683C110.9,79.57,111.119,78.8,112.59,79.118Zm1.049,1.658c.1-.754-.361-.875-1-.887s-1,.124-.995.9.286,1.1,1.09,1.065c.742-.05.945-.427.9-1.1Z",
    transform: "translate(-64.893 -46.276)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M100.161,82.407c-1.417.344-1.658-.344-1.683-1.658S98.831,79,100.2,79s1.737.456,1.753,1.778C101.972,82.175,101.525,82.7,100.161,82.407Zm.957-1.687c.129-.763-.311-.887-.97-.87s-1.02.128-1.007.912.361,1.061,1.132,1.057S101.152,81.35,101.119,80.72Z",
    transform: "translate(-57.661 -46.253)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M112.18,96.347a150.5,150.5,0,0,1-15.29,0c.141-.568.613-.452.991-.452H111.2C111.579,95.892,112.043,95.788,112.18,96.347Z",
    transform: "translate(-56.732 -56.14)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M112.227,63.074H97.12V62.66h15.112Z",
    transform: "translate(-56.867 -36.685)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M127.009,47.256c.228,1.289-.1,1.919-1.579,1.878-1.285-.037-1.844-.274-1.795-1.712.041-1.243.22-1.865,1.658-1.782C126.491,45.71,127.412,45.723,127.009,47.256Zm-1.6,1.015c.829.124.829-.414.829-.991,0-.663-.2-.962-.937-.957-.829,0-.792.493-.829,1.061C124.432,48.106,124.705,48.4,125.41,48.272Z",
    transform: "translate(-72.39 -26.715)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M112.737,49.078c-1.509.315-1.907-.361-1.907-1.791,0-1.3.414-1.658,1.658-1.612,1.165.037,1.994.054,1.815,1.616C114.187,48.373,114.39,49.488,112.737,49.078Zm-.075-2.727c-.663-.079-1,.153-1.007.883s.058,1.19.962,1.119c.6-.046,1.053-.075,1.04-.862C113.644,46.781,113.524,46.267,112.662,46.35Z",
    transform: "translate(-64.894 -26.738)",
    fill: "#acadb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M100.285,49.051c-1.534.34-1.778-.369-1.807-1.658-.029-1.364.381-1.741,1.724-1.724s1.815.327,1.749,1.724C101.889,48.649,101.707,49.47,100.285,49.051Zm-.195-.721c.589.046,1.082,0,1.036-.829-.037-.613.066-1.214-.9-1.2-.792,0-1.082.3-1.086,1.069,0,.7.24,1.04.949.957Z",
    transform: "translate(-57.661 -26.737)",
    fill: "#acadb1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComImage);
export default __webpack_public_path__ + "static/media/ComImage.70438e0011632ba70f9139a9cc254897.svg";
export { ForwardRef as ReactComponent };